var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.85,
    strokeWidth: 1.667,
    d: "m10.486 17.028 6.51-6.714c1.6-1.658 1.834-4.368.322-6.1a4.2 4.2 0 0 0-1.355-1.036 4.08 4.08 0 0 0-3.304-.095 4.2 4.2 0 0 0-1.41.956l-1.221 1.268-1.053-1.094c-1.608-1.65-4.236-1.89-5.916-.331-.424.39-.765.866-1.004 1.398a4.42 4.42 0 0 0-.092 3.406c.21.545.525 1.04.927 1.454l6.68 6.888a.64.64 0 0 0 .916 0"
  })));
};
export default SvgHeart;